import React from "react";

const BaseUrl = "https://theapplified.com/kingskraft/api/v1/";

export const ACCEPT_HEADER = "application/x.kingskraft.v1+json";

export const location_url = BaseUrl + "getlocationdata";
export const place_url = BaseUrl + "getpropertydata";
export const postinquiry_url = BaseUrl + "postinquiry";
export const contactus_url = BaseUrl + "contact-us";
export const subscribes = BaseUrl + "subscribes";
export const getslugproperty = BaseUrl + "getslugproperty/";
export const get_hotels = BaseUrl + "get-hotels";
